import React, { useEffect } from 'react';
import { useTheme } from '@repo/shared';
import { Link } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchool, faUserGraduate, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';

// Modern styling
const containerStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, var(--primary-color-semitransparent3) 0%, var(--primary-color-semitransparent4) 100%)',
  paddingTop: '60px',
  paddingBottom: '60px'
};

const headerStyle = {
  textAlign: 'center',
  marginBottom: '60px'
};

const logoStyle = {
  width: '120px',
  height: '120px',
  borderRadius: '50%',
  marginBottom: '30px',
  boxShadow: '0 10px 30px var(--primary-color-semitransparent3)',
  border: '4px solid transparent',
  objectFit: 'cover'
};

const titleStyle = {
  fontSize: '48px',
  fontWeight: '700',
  color: '#2c3e50',
  marginBottom: '15px',
  letterSpacing: '-0.5px'
};

const subtitleStyle = {
  fontSize: '18px',
  color: '#7f8c8d',
  fontWeight: '500'
};

const cardStyle = {
  border: 'none',
  borderRadius: '16px',
  overflow: 'hidden',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  boxShadow: '0 4px 15px var(--primary-color-semitransparent3)',
  height: '100%',
  background: 'linear-gradient(135deg, #ffffff 0%, #f0f8fb 100%)',
  cursor: 'pointer'
};

const cardHoverStyle = {
  transform: 'translateY(-8px)',
  boxShadow: '0 12px 30px var(--primary-color-semitransparent3)'
};

const linkStyle = {
  textDecoration: "none",
  color: "inherit"
};

export default function Home({ setToken }) {
  const { appTheme } = useTheme();
  const [hoveredCard, setHoveredCard] = React.useState(null);

  useEffect(() => {
    document.title = `${appTheme?.appName} - Home`;

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = new URL(`./images/${appTheme?.logo || 'logo-default.png'}`, import.meta.url).href;
    
  }, [appTheme]);

  // Dynamic styles based on theme
  const iconContainerStyle = {
    width: '80px',
    height: '80px',
    borderRadius: '12px',
    background: `linear-gradient(135deg, var(--primary-dark-color) 0%, var(--primary-light-color) 100%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 25px',
    boxShadow: '0 8px 20px var(--primary-color-semitransparent3)'
  };

  const menuItems = [
    {
      to: "/classes",
      icon: faChalkboardTeacher,
      title: "Classes",
      text: "Manage and organize your classes."
    },
    {
      to: "/students",
      icon: faUserGraduate,
      title: "Students",
      text: "Track and manage student information."
    },
    {
      to: "/schools",
      icon: faSchool,
      title: "Schools",
      text: "Manage school details and settings."
    }
  ];

  return(
    <div style={containerStyle}>
      <Container className="py-5">
        <div style={headerStyle}>
          <img 
            alt="logo"
            src={new URL(`../../images/${appTheme?.logo || 'logo-default.png'}`, import.meta.url).href}
            style={logoStyle}
          />
          <h1 style={titleStyle}>Welcome to {appTheme?.appName}</h1>
          <p style={subtitleStyle}>Select an option below to get started.</p>
        </div>

        <Row xs={1} md={2} lg={3} className="g-4 justify-content-center">
          {menuItems.map((item, index) => (
            <Col key={index} className="d-flex">
              <Link to={item.to} style={linkStyle} className="w-100">
                <Card 
                  style={{
                    ...cardStyle,
                    ...(hoveredCard === index && cardHoverStyle)
                  }}
                  onMouseEnter={() => setHoveredCard(index)}
                  onMouseLeave={() => setHoveredCard(null)}
                  className="w-100"
                >
                  <Card.Body className="d-flex flex-column justify-content-center align-items-center p-5">
                    <div style={iconContainerStyle}>
                      <FontAwesomeIcon icon={item.icon} size="2x" style={{ color: '#fff' }} />
                    </div>
                    <Card.Title style={{
                      fontSize: '24px',
                      fontWeight: '700',
                      color: '#2c3e50',
                      marginBottom: '12px'
                    }}>
                      {item.title}
                    </Card.Title>
                    <Card.Text style={{
                      color: '#7f8c8d',
                      fontSize: '15px',
                      lineHeight: '1.6'
                    }}>
                      {item.text}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}